import paymentMethodTypes from '../constants/paymentMethodTypeConstants.js';
var checkIsApplePayCheckout = function checkIsApplePayCheckout(type) {
  return type === paymentMethodTypes.APPLE_PAY || type === paymentMethodTypes.APPLE_PAY_EXPRESS;
};
var checkIsApplePayExpressCheckout = function checkIsApplePayExpressCheckout(type) {
  return type === paymentMethodTypes.APPLE_PAY_EXPRESS;
};
var checkIsApplePayStandardCheckout = function checkIsApplePayStandardCheckout(type) {
  return type === paymentMethodTypes.APPLE_PAY;
};
var checkIsCardCheckout = function checkIsCardCheckout(type) {
  return type === paymentMethodTypes.CARD;
};
var checkIsExpressCheckout = function checkIsExpressCheckout(type) {
  return checkIsApplePayCheckout(type) || checkIsGooglePayCheckout(type);
};
var checkIsExpressEligibleCheckout = function checkIsExpressEligibleCheckout(type) {
  return type === paymentMethodTypes.EXPRESS_ELIGIBLE;
};
var checkIsGooglePayCheckout = function checkIsGooglePayCheckout(type) {
  return type === paymentMethodTypes.GOOGLE_PAY;
};
export { checkIsApplePayCheckout, checkIsApplePayExpressCheckout, checkIsApplePayStandardCheckout, checkIsCardCheckout, checkIsExpressCheckout, checkIsExpressEligibleCheckout, checkIsGooglePayCheckout };